module.exports = __webpack_public_path__ + "static/media/Diver.c06a59d1.jpg";